/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import { createApp } from 'vue';

/**
 * Next, we will create a fresh Vue application instance. You may then begin
 * registering components with the application instance so they are ready
 * to use in your application's views. An example is included for you.
 */

const app = createApp({});

// Register Admin Components
import AdminLayout from './components/admin/AdminLayout.vue';
import UsersList from './components/admin/UsersList.vue';
import SettingsPage from './components/admin/SettingsPage.vue';
import RolesPage from './components/admin/RolesPage.vue';
import PermissionsPage from './components/admin/PermissionsPage.vue';
import RegistrationQueuePage from './components/admin/RegistrationQueuePage.vue';
import RentSeekerActivePackagePage from './components/admin/RentSeekerActivePackagePage.vue';
import RentSeekerShortlistPage from './components/admin/RentSeekerShortlistPage.vue';
import CustomersPage from './components/admin/CustomersPage.vue';
import BillingPage from './components/admin/BillingPage.vue';
import PropertiesPage from './components/admin/PropertiesPage.vue';
import PackageChargesPage from './components/admin/PackageChargesPage.vue';
import AdminDashboard from './components/admin/AdminDashboard.vue';

app.component('admin-layout', AdminLayout);
app.component('users-list', UsersList);
app.component('settings-page', SettingsPage);
app.component('roles-page', RolesPage);
app.component('permissions-page', PermissionsPage);
app.component('registration-queue-page', RegistrationQueuePage);
app.component('rent-seeker-active-package-page', RentSeekerActivePackagePage);
app.component('rent-seeker-shortlist-page', RentSeekerShortlistPage);
app.component('customers-page', CustomersPage);
app.component('billing-page', BillingPage);
app.component('properties-page', PropertiesPage);
app.component('package-charges-page', PackageChargesPage);
app.component('admin-dashboard', AdminDashboard);

/**
 * Finally, we will attach the application instance to a HTML element with
 * an "id" attribute of "app". This element is included with the "auth"
 * scaffolding. Otherwise, you will need to add an element yourself.
 */

app.mount('#app');
